/* eslint-disable import/no-mutable-exports */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { TTemplate } from '@/helpers/createTemplate';
import {
  ImageNoRaces,
  NoRacesWrapper,
  TextPrimary,
  TextSecondary,
} from '../styles/NoRaces.styles';
import NoRacesMascot from '../../../../../assets/sterlingparker/images/backgrounds/saddle.png';

export const template: TTemplate = {
  wrapper: <NoRacesWrapper />,
  text: (
    <>
      <TextPrimary>
        <FormattedMessage id="racing.errorMessages.noRacesAvailable" />
      </TextPrimary>
      <TextSecondary>
        <FormattedMessage id="racing.errorMessages.noRacesAvailableSubtext" />
      </TextSecondary>
    </>
  ),
  image: <ImageNoRaces src={NoRacesMascot} />,
};

export default template;
